'use client'

import { useState } from 'react'

import { useOptionalSession } from '@mntn-dev/session/frontend'
import { useInterval } from '@mntn-dev/ui-utilities'
import type { VercelEnvironment } from '@mntn-dev/utilities'

declare global {
  interface Window {
    // biome-ignore lint/suspicious/noExplicitAny: It's fine
    pendo: any
  }
}

export const PendoProvider = ({
  environment,
}: {
  environment: VercelEnvironment
}) => {
  const session = useOptionalSession()
  const [delay, setDelay] = useState<number | null>(100)

  useInterval(() => {
    if (!window.pendo) return

    window.pendo.initialize({
      visitor: session
        ? {
            id: session.profile.emailAddress,
            qf_userId: session.profile.userId,
            qf_organizationType: session.authz.organizationType,
            ...environment,
          }
        : {
            id: 'anonymous',
            ...environment,
          },
    })

    setDelay(null)
  }, delay)

  return null
}
